import rec1 from "../assets/landing/rec-1.jpg";
import rec2 from "../assets/landing/rec-2.jpg";
import rec3 from "../assets/landing/rec-3.jpg";
import rec4 from "../assets/landing/rec-4.jpg";
import rec5 from "../assets/landing/rec-5.jpg";
import rec6 from "../assets/landing/rec-6.jpg";
import rec7 from "../assets/landing/rec-7.jpg";
import rec8 from "../assets/landing/rec-8.jpg";
import rec9 from "../assets/landing/rec-9.jpg";
import bookTokenization from "../assets/landing/book-tokenization.webp";
import bookBearProof from "../assets/landing/book-bear-proof.webp";

/** Figma comment: "Careers" points at the Gamma Prime careers page. */
export const navLinks = [
  { id: "about", name: "About" },
  { id: "publications", name: "Publications" },
  { id: "books", name: "Books" },
  { id: "interviews", name: "Interviews" },
  { id: "careers", name: "Careers", href: "https://gammaprime.com/careers" },
];

/** Figma comments marked "Partners" and "Contact me" for deletion. */
export const footerLinks = [
  { id: "home", name: "Home" },
  { id: "about", name: "About me" },
  { id: "publications", name: "Publications" },
  { id: "careers", name: "Careers", href: "https://gammaprime.com/careers" },
];

export const contactEmail = "ev@gammaprime.com";

/**
 * Build a mailto link to the contact email with a pre-filled subject line.
 * Each section passes its own subject so Evan can see where the email came from.
 */
export const mailTo = (subject: string) =>
  `mailto:${contactEmail}?subject=${encodeURIComponent(subject)}`;

export const socialLinks = {
  linkedin: "https://www.linkedin.com/in/evanszu/",
  x: "https://x.com/GammaEvan",
};

export const heroDisciplines = [
  { no: "01", name: "Derivatives", meta: "30+ yrs" },
  { no: "02", name: "Artificial Intelligence", meta: "Since 1995" },
  { no: "03", name: "Digital Assets", meta: "Since 2015" },
  { no: "04", name: "Biotechnology", meta: "Since 2018" },
];

export const featuredIn = [
  "Cointelegraph",
  "Stanford Engineering",
  "Bitget",
  "The Rollup",
  "Forward Guidance",
  "be in crypto",
];

export const noteDisciplines = [
  { no: "01", name: "Finance", meta: "Derivatives & Structured Products" },
  { no: "02", name: "AI", meta: "ML for Markets · Since 1995" },
  { no: "03", name: "Web3", meta: "On-Chain Yield · Since 2015" },
  { no: "04", name: "Science", meta: "Biotech & Drug Discovery" },
];

export const noteStats = [
  { value: "Stanford", label: "Doctorate" },
  { value: "Brown", label: "Cum Laude" },
  { value: "30+ yr", label: "Derivatives" },
  { value: "29", label: "publications & books" },
];

export const publications = [
  {
    year: "2016",
    title:
      "“Factual accuracy and the cultural context of science in popular media: Perspectives of media makers, middle school students, and university students on an entertainment television program”",
    source: "Journal of Research in Science Teaching",
    link: "https://pubmed.ncbi.nlm.nih.gov/27340172/",
  },
  {
    year: "2016",
    title:
      "“The development and validation of a learning progression for argumentation in science”",
    source: "Stanford Graduate School of Education",
    link: "https://www.researchgate.net/publication/299602661_The_development_and_validation_of_a_learning_progression_for_argumentation_in_science",
  },
  {
    year: "2014",
    title:
      "“Ethnically Diverse Students’ Knowledge Structures in First-Semester Organic Chemistry”",
    source: "Journal of Chemical Education",
    link: "https://www.researchgate.net/publication/263775747_Ethnically_Diverse_Students'_Knowledge_Structures_in_FirstSemester_Organic_Chemistry",
  },
  {
    year: "2014",
    title:
      "“A New Learning Progression for Student Argumentation in Scientific Contexts”",
    source: "AERA Annual Meeting",
    link: "https://www.semanticscholar.org/paper/A-NEW-LEARNING-PROGRESSION-FOR-STUDENT-IN-CONTEXTS-Henderson-Osborne/dc9626b13bdb91acf343da48661ea8c046ebe604",
  },
  {
    year: "2014",
    title:
      "“Factors Contributing to Problem-Solving Performance in First-Semester Organic Chemistry”",
    source: "Journal of Chemical Education",
    link: "https://pubs.acs.org/doi/10.1021/ed400696c",
  },
  {
    year: "2013",
    title:
      "“Self-regulated learning study strategies and academic performance in undergraduate organic chemistry: An investigation examining ethnically diverse students”",
    source: "Journal of Research in Science Teaching",
    link: "https://onlinelibrary.wiley.com/doi/10.1002/tea.21095",
  },
  {
    year: "2012",
    title:
      "“Scientific Reasoning and Argumentation from a Bayesian Perspective”",
    source: "Perspectives on Scientific Argumentation",
    link: "https://link.springer.com/chapter/10.1007/978-94-007-2470-9_4",
  },
  {
    year: "2011",
    title: "“Understanding Academic Performance in Organic Chemistry”",
    source: "Journal of Chemical Education",
    link: "https://eric.ed.gov/?id=EJ943622",
  },
  {
    year: "1997",
    title:
      "“An Interactive Web Site Providing Major Histocompatibility Ligand Predictions: Application to HIV Research”",
    source: "AIDS Research and Human Retroviruses",
    link: "https://pubmed.ncbi.nlm.nih.gov/9135870/",
  },
];

/** Nine cards. Figma comment: no view counter and no "View Summary" link. */
export const recordings = [
  {
    title:
      "His Portfolio Beat Bitcoin, Gold, and Stocks for 5 Years. Here's What's Actually In It",
    description:
      "What does a five-year portfolio with no drawdown year actually hold - and why can't most investors access it?",
    speaker: "Evan Szu, CEO at Gamma Prime",
    date: "Apr 29, 2026",
    duration: "46 min",
    link: "https://www.youtube.com/watch?v=aQrJxTDnavE",
    image: rec1,
  },
  {
    title: "Evan Szu on Why Recession Is Coming Before Inflation",
    description:
      "Evan Szu joins us on The Rollup to explains how a recession is coming before inflation.",
    speaker: "Evan Szu, CEO at Gamma Prime",
    date: "May 23, 2026",
    duration: "13 min",
    link: "https://www.youtube.com/watch?v=Mj-IoX8MqK8",
    image: rec2,
  },
  {
    title:
      "Why Most AI in Trading Fails — and How to Constrain Its Power Effectively",
    description:
      "Most traders are still debating whether AI can truly manage a portfolio—but Evan Szu's autonomous trading system has been doing it since 2019.",
    speaker: "Evan Szu, CEO at Gamma Prime",
    date: "Apr 9, 2026",
    duration: "31 min",
    link: "https://www.youtube.com/watch?v=pKUWvot_F8I",
    image: rec3,
  },
  {
    title:
      "Why Most Portfolios Fail — and How Uncorrelated Assets Change Everything",
    description:
      "In this talk, Evan Szu breaks down the real secret to superior investing: optimizing returns vs. risk through diversification and uncorrelated assets.",
    speaker: "Evan Szu, CEO at Gamma Prime",
    date: "Nov 4, 2025",
    duration: "9 min",
    link: "https://www.youtube.com/watch?v=3jchuv51eyI",
    image: rec4,
  },
  {
    title: "2026 Market Prediction ( 30+ Years of Experience )",
    description:
      "For years, investors have been told that building a diversified portfolio means balancing stocks and bonds.",
    speaker: "Evan Szu, CEO at Gamma Prime",
    date: "Jun 23, 2026",
    duration: "13 min",
    link: "https://www.youtube.com/watch?v=-USeRJ13Dc0&t=34s",
    image: rec5,
  },
  {
    title: "How to Diversify Portfolio?",
    description:
      "Gamma Prime CEO Evan Szu explains how wealthy investors, family offices, and accredited investors think about diversification beyond traditional markets.",
    speaker: "Evan Szu, CEO at Gamma Prime",
    date: "Jul 1, 2026",
    duration: "6 min",
    link: "https://www.youtube.com/watch?v=XsBJU0uWDsk",
    image: rec6,
  },
  {
    title: "I Beat The Market for My Family (Here's How)",
    description:
      "Most investors rely on stocks, bonds, or Bitcoin - but what if the real edge comes from what everyone else ignores?",
    speaker: "Evan Szu, CEO at Gamma Prime",
    date: "Apr 3, 2026",
    duration: "10 min",
    link: "https://www.youtube.com/watch?v=rHwmhe8WtdY",
    image: rec7,
  },
  {
    title: "How I Delivered Double-Digit Returns With Zero Down Years",
    description:
      "Evan Szu, CEO of Gamma Prime, shares the origin story behind the platform - revealing how blending non-correlated strategies across private markets can generate consistent, high returns with minimal volatility.",
    speaker: "Evan Szu, CEO at Gamma Prime",
    date: "Apr 23, 2026",
    duration: "14 min",
    link: "https://www.youtube.com/watch?v=Gku3Wss9GTI",
    image: rec8,
  },
  {
    title: "Bridging TradFi & DeFi w/ Sebastien Borget, Alex Esin & more",
    description:
      "Held on June 30th, 2025, during EthCC in France, the forum brought together top founders, venture leaders, and decision-makers.",
    speaker: "Evan Szu, CEO at Gamma Prime",
    date: "Oct 8, 2025",
    duration: "8 min",
    link: "https://www.youtube.com/watch?v=pucIcogYIm4",
    image: rec9,
  },
];

/** Figma comment: "take title & link from video #5". */
export const featuredRecording = {
  badge: "Now Featured",
  show: "The Allocator",
  date: recordings[4].date,
  title: recordings[4].title,
  link: recordings[4].link,
  host: "Hosted by Marcus Whitfield",
  duration: recordings[4].duration,
  listens: "240K listens",
  tags: ["Tokenization", "Allocations", "Yield"],
};

const chapters = [
  { no: "01", title: "I. The Institutional Yield Stack" },
  { no: "02", title: "II. Mechanics of On-Chain Derivatives" },
  { no: "03", title: "III. Risk, Custody, and Counterparty" },
  { no: "04", title: "IV. The Tokenization Thesis" },
];

export const books = [
  {
    year: "2026",
    title: "The Age of Tokenization: the $100 Trillion Opportunity",
    subtitle:
      "The $100 Trillion Opportunity is Awaiting. Will you be able to leverage it?",
    description:
      "An institutional thesis on bringing structured-yield strategies historically reserved for endowments and family offices into a transparent, on-chain framework.",
    quote:
      "“The next decade of yield will not be invented in Wall Street boardrooms — it will be assembled, transparently, on-chain.”",
    chapters,
    pages: "284",
    released: "2026",
    cover: bookTokenization,
    /** Cover sits on the left, copy on the right. */
    coverSide: "left" as const,
  },
  {
    year: "2025",
    title: "Bear Proof",
    subtitle:
      "How I managed to avoid a negative year in my 30+ years trading career",
    description:
      "In this book I’ve described the basic principals behind understanding and mastering uncorrelated assets and how to leverage them to ensure a real diversified and bullet proof portfolio.",
    quote:
      "“Staying diversified is not about buying a bunch of different assets. It’s about understanding uncorrelated assets.”",
    chapters,
    pages: "284",
    released: "2024",
    cover: bookBearProof,
    coverSide: "right" as const,
  },
];
